var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLieFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-lie-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-lie-filled",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7F8BDB",
    cx: 5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    y1: 2.5,
    x2: 23.5,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 5,
    width: 23,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49999985,5 L21.4999998,5 C21.4998399,3.82475093 20.7000875,2.80032588 19.56,2.515 C17.9836351,2.12090878 16.8013615,1.82534036 16.013179,1.62829475 C15.3942503,1.47356259 14.4658573,1.24146433 13.228,0.932 C12.3316236,0.70777723 11.3819312,0.909124629 10.6536587,1.47779456 C9.92538607,2.0464645 9.49979339,2.91900519 9.49999985,3.843 L9.49999985,5 Z",
    id: "Path",
    fill: "#7F8BDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLieFilled);
export default __webpack_public_path__ + "static/media/icons-lie-filled.06495e2d0f5c3a87d124400b9c2e5820.svg";
export { ForwardRef as ReactComponent };